var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6654 10.5604L16.4139 8.68237L13.0851 12.0112L16.4136 15.3397L19.6764 13.4555C20.1852 13.1464 20.4888 12.6064 20.4888 12.0112C20.4888 11.416 20.185 10.876 19.6654 10.5604Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0846 12.0111L4.01762 2.87891C3.70226 3.19427 3.51074 3.62219 3.51074 4.09523V19.8992C3.51074 20.3723 3.70226 20.8002 4.01762 21.1158L13.0846 12.0111Z",
    fill: "#01DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0855 12.0112L16.4143 8.68244L16.4196 8.67716L11.9594 6.10916L6.07991 2.65364C5.55047 2.327 4.90847 2.31572 4.36775 2.6198C4.24391 2.69852 4.13111 2.77748 4.01855 2.87876L13.0855 12.0112Z",
    fill: "#00F076"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01855 21.1156C4.13111 21.2169 4.24391 21.2959 4.36775 21.3746C4.63799 21.521 4.91975 21.5999 5.20127 21.5999C5.50535 21.5999 5.79815 21.51 6.06863 21.3523L11.9592 17.9133L16.4194 15.3453L16.4141 15.34L13.0855 12.0112L4.01855 21.1156Z",
    fill: "#F63448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.4831a5c1d870cf0cadffaa1371a3bb9c.svg";
export { ForwardRef as ReactComponent };